import classNames from 'classnames';
import { ReactElement } from 'react';

import AccordionMarketingCard, {
    IAccordionMarketingCardProps,
} from '~components/AccordionMarketingCard/AccordionMarketingCard';
import Grid from '~components/_layout/Grid/Grid';

interface IAccordionMarketingProps {
    backgroundsurface: SupportedBackgroundColor;
    textcolor: SupportedTextColor;
    children: ReactElement<IAccordionMarketingCardProps>[];
}

const AccordionMarketing = ({
    backgroundsurface,
    textcolor,
    children,
}: React.PropsWithChildren<IAccordionMarketingProps>) => {
    const childModules = children.filter((child) => typeof child !== 'string');
    return (
        <Grid>
            <div className="col-span-4 md:col-span-8 lg:col-span-12 py-8 lg:px-16">
                <article className={classNames(backgroundsurface, textcolor, 'md:px-8 lg:px-48')}>
                    {childModules.length &&
                        childModules.map((child, i) => (
                            <div key={i}>
                                {i > 0 && <hr className="my-10 text-gray-hr" />}
                                <AccordionMarketingCard {...child.props}></AccordionMarketingCard>
                            </div>
                        ))}
                </article>
            </div>
        </Grid>
    );
};

export default AccordionMarketing;
